export function filterByStatus(statuses, series, statusType) {
  // Filter series-level statuses + sort by updatedAt DESC
  const matchingStatuses =
    statuses
      ?.filter(
        (status) =>
          status.targetType === "series" &&
          status.userStatus === statusType
      )
      .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)) ?? [];

  // Create a lookup map to preserve order
  const seriesMap = new Map(
    series?.map((s) => [String(s._id), s]) ?? []
  );

  // Build filteredSeries in the same order as statuses
  const filteredSeries = matchingStatuses
    .map((status) => seriesMap.get(String(status.seriesId)))
    .filter(Boolean);

  return { filteredSeries };
}